import { createSlice } from '@reduxjs/toolkit';
import SearchUseCase from './searchUseCase';

// Initial state for search results
const initialState = {
  searchResults: [],
  resultCount: 0,
  requestStatus: '',
  error: '',
  isRequestInProgress: false,
  profilePhotoCollection: [],
  suggestionList: [],
  refiners: [],
  latency: 0,
  browsePageSearchFlag: false,
  flagForSuggestedOrRecentSearch: '',
  previewToken: '',
  nestedRefiners: [],
  selectedRefiners: [],
  selectedRefinersOnPageLoad: [],
  refinersClicked: [],
  ontologyData: [],
  flagForContentAge: false,
  flagForClear: false,
  browseConfigJSON: {},
  browseTitles:{},
  isSemanticSearchEnabled: false,
  searchModeBrowse: 'Keyword' as 'Keyword' | 'Semantic',
  isLoadingPreferences: true
};

/**
 * search reducer with search api action type and set the state
 * reducer is part of redux and here extraReducers method is used to
 * set dynamic case for async functions actions. once we receive the
 * fullfil action, we will set the value to state passed as async action method response
 *
 */
const browseSearchReducer = createSlice({
  name: 'search',
  initialState,
  reducers: {
    // resetting the search results to initial state i.e., empty
    resetSearchResults() {
      return initialState;
    },
    // Setting up a flag value to identify the search initiated from browse page
    setBrowsePageSearchFlag(state, action) {
      state.browsePageSearchFlag = action.payload;
    },
    // Setting up the flag value for either Recent Search Click or Suggestions Click
    enableFlagForSuggestedOrRecentSearch(state, action) {
      state.flagForSuggestedOrRecentSearch = action.payload;
    },
    // To set preview token in Redux
    setPreviewToken(state, action) {
      state.previewToken = action.payload;
    },
    // to set the selected refiners values on refiner apply button click
    setSelectedRefiners(state, action) {
      state.selectedRefiners = action.payload;
    },
    // to set the selected refiners on page load
    setSelectedRefinersOnPageLoad(state, action) {
      state.selectedRefinersOnPageLoad = action.payload;
    },
    // to set the  refiners clicked before apply
    setRefinersClicked(state, action) {
      state.refinersClicked = action.payload;
    },
    // to set if the contentAge clicked before apply
     setFlagForContentAge(state, action) {
      state.flagForContentAge = action.payload;
    },
    // to set if the contentAge clicked before apply
    setBrowseConfigJSON(state, action) {
      state.browseConfigJSON = action.payload;
    },
    //to store the browse title ,used in preview icon tracking to obtain the browse page title
    setBrowseTitles(state, action) {
      state.browseTitles = action.payload;
    },
    // to set if the contentAge clicked before apply
     setFlagForClear(state, action) {
          state.flagForClear = action.payload;
        },
    // Set toggle type for keyword/semantic search
      setSearchModeBrowse(state, action) {
        state.searchModeBrowse = action.payload;
      },
      // Set loading preferences flag
      setIsLoadingPreferences(state, action) {
        state.isLoadingPreferences = action.payload;
      }
  },
  extraReducers: (builder) => {
    // builder.addCase(@param1:async function promise, @param2: call back handler function)
    builder.addCase(SearchUseCase.doSearch.fulfilled, (state, action) => {
      state.searchResults = action.payload.results;
      state.resultCount = action.payload.resultCount;
      state.isSemanticSearchEnabled = action.payload.isSemanticSearchEnabled ?? false;
      state.requestStatus = action.meta.requestStatus
        ? action.meta.requestStatus
        : '';
      state.error = '';
      state.isRequestInProgress = false;
      state.refiners = action.payload.refiners;
      state.latency = action.payload.latency;
      state.nestedRefiners = action.payload.nestedRefiners;
    });

    // added case to handle rejected scenario.
    builder.addCase(SearchUseCase.doSearch.rejected, (state, action) => {
      state.error = action.error.message ? action.error.message : '';
      state.requestStatus = action.meta.requestStatus
        ? action.meta.requestStatus
        : '';
      state.resultCount = 0;
      state.searchResults = [];
      state.isRequestInProgress = false;
      state.refiners = [];
      state.latency = 0;
      state.nestedRefiners = [];
    });

    builder.addCase(SearchUseCase.doSearch.pending, (state, _action) => {
      state.resultCount = 0;
      state.searchResults = [];
      state.isRequestInProgress = true;
      state.requestStatus = '';
      state.refiners = [];
      state.latency = 0;
      state.nestedRefiners = [];
    });

    // Case for Suggestions BAI call pending.
    builder.addCase(
      SearchUseCase.queryRecommondations.pending,
      (state, action) => {
        state.suggestionList = [];
      }
    );

    // Case for Suggestions BAI call fulfilled.
    builder.addCase(
      SearchUseCase.queryRecommondations.fulfilled,
      (state, action) => {
        state.suggestionList = action.payload.suggestionList;
      }
    );
    // Case for fetchUserPreferences fulfilled
    builder.addCase(SearchUseCase.fetchUserPreferences.fulfilled, (state, action) => {
      state.searchModeBrowse = action.payload.searchMode;
      state.isLoadingPreferences = false;
    });

    // Case for fetchUserPreferences rejected
    builder.addCase(SearchUseCase.fetchUserPreferences.rejected, (state, action) => {
      state.searchModeBrowse = 'Keyword';
      state.isLoadingPreferences = false;
    });

    // Case for fetchUserPreferences pending
    builder.addCase(SearchUseCase.fetchUserPreferences.pending, (state, _action) => {
      state.isLoadingPreferences = true;
    });
  }
});

export const {
  setPreviewToken,
  resetSearchResults,
  setBrowsePageSearchFlag,
  enableFlagForSuggestedOrRecentSearch,
  setSelectedRefiners,
  setSelectedRefinersOnPageLoad,
  setRefinersClicked,
  setFlagForContentAge,
  setFlagForClear,
  setBrowseConfigJSON,
  setBrowseTitles,
  setSearchModeBrowse,
  setIsLoadingPreferences
} = browseSearchReducer.actions;
export default browseSearchReducer.reducer;
